module.exports = __webpack_public_path__ + "static/masonry-a7bb1490f07809259fad0092d5b9ee46.jpg";